"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
var Money_1 = __importDefault(require("components/Money"));
var StatBlock_1 = __importDefault(require("containers/Dashboard/StatBlock"));
var Slider_1 = __importDefault(require("shared/components/Slider/Slider"));
var SliderItem_1 = __importDefault(require("shared/components/Slider/SliderItem"));
var Text_1 = __importDefault(require("shared/components/Text"));
var PREFIX = 'OptimiseStatGroup';
var classes = {
    defaultTitle: "".concat(PREFIX, "-defaultTitle"),
    borderRight: "".concat(PREFIX, "-borderRight"),
    highlightText: "".concat(PREFIX, "-highlightText"),
    alignLeft: "".concat(PREFIX, "-alignLeft"),
    col: "".concat(PREFIX, "-col"),
    selected: "".concat(PREFIX, "-selected"),
    hover: "".concat(PREFIX, "-hover"),
    header: "".concat(PREFIX, "-header"),
    verDivider: "".concat(PREFIX, "-verDivider"),
    headerParagraph: "".concat(PREFIX, "-headerParagraph"),
    statItem: "".concat(PREFIX, "-statItem"),
    wrapper: "".concat(PREFIX, "-wrapper"),
    link: "".concat(PREFIX, "-link"),
};
var StyledRow = (0, styles_1.styled)(reactstrap_1.Row)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.defaultTitle)] = __assign(__assign({}, theme.typography.h1), { lineHeight: '1', fontSize: '2.5rem', marginBottom: theme.spacing(0.5), display: 'block' }),
        _b[".".concat(classes.borderRight)] = {
            borderRight: "1px solid ".concat(theme.palette.secondary.dark),
            minWidth: 150,
        },
        _b[".".concat(classes.highlightText)] = {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
        },
        _b[".".concat(classes.alignLeft)] = {
            textAlign: 'left',
        },
        _b[".".concat(classes.col)] = {
            display: 'flex',
            height: 128,
        },
        _b[".".concat(classes.selected)] = {
            borderColor: theme.palette.primary.main,
            borderRadius: 12,
        },
        _b[".".concat(classes.hover)] = {
            '&:hover': {
                background: theme.palette.secondary.light,
                borderRadius: 12,
            },
            ':focus-visible': __assign({}, theme.focusVisibleStyles),
        },
        _b[".".concat(classes.header)] = {
            width: 192,
            height: '100%',
            '&:hover': {
                background: theme.palette.secondary.light,
                borderRadius: 12,
            },
            position: 'relative',
            border: 'none',
            padding: theme.spacing(2),
            margin: 0,
        },
        _b[".".concat(classes.verDivider)] = {
            width: 1,
            background: theme.palette.secondary.main,
            margin: theme.spacing(2),
            marginRight: 0,
        },
        _b[".".concat(classes.headerParagraph)] = {
            marginBottom: 0,
        },
        _b[".".concat(classes.statItem)] = {
            width: 160,
            height: '100%',
        },
        _b["&.".concat(classes.wrapper)] = {
            padding: theme.spacing(2, 0),
        },
        _b[".".concat(classes.link)] = {
            borderRadius: 6,
            ':focus-visible': __assign(__assign({}, theme.focusVisibleStyles), theme.focusVisibleLinkStyles),
        },
        _b);
});
var OptimiseStatGroup = function (_a) {
    var headerStat = _a.headerStat, otherStats = _a.otherStats, selected = _a.selected;
    return ((0, jsx_runtime_1.jsx)(StyledRow, __assign({ as: "ul", className: (0, clsx_1.default)('non-sticky', classes.wrapper), "data-testid": "stat-wrapper" }, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Col, __assign({ className: classes.col, as: "li" }, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: "/recommendations", className: classes.link }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ type: "button", className: (0, clsx_1.default)(classes.borderRight, classes.alignLeft, classes.header) }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: classes.defaultTitle }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: headerStat.amount, isShortened: true }) })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2, className: classes.headerParagraph }, { children: ["detected in ", (0, jsx_runtime_1.jsx)("strong", { children: "savings " }), (0, jsx_runtime_1.jsx)("br", {}), "with ", (0, jsx_runtime_1.jsx)("strong", __assign({ className: classes.highlightText }, { children: (0, end2end_1.handlePlural)('action')(headerStat.count) }))] }))] })) })), (0, jsx_runtime_1.jsx)("div", { className: classes.verDivider }), (0, jsx_runtime_1.jsx)(Slider_1.default, { children: otherStats
                        .filter(function (stat) { return stat.actionCount && stat.actionCount > 0; })
                        .map(function (statItem) { return ((0, jsx_runtime_1.jsx)(SliderItem_1.default, __assign({ className: (0, clsx_1.default)(classes.hover, classes.statItem, statItem.type && (selected === null || selected === void 0 ? void 0 : selected.includes(statItem.type)) && classes.selected) }, { children: (0, jsx_runtime_1.jsx)(StatBlock_1.default, { item: statItem, amountFormat: "K" }) }), statItem.type)); }) })] })) })));
};
exports.default = OptimiseStatGroup;
